document.addEventListener('DOMContentLoaded', () => {
    const modals = [
        {
            id: 'videoModal',
            openBtnId: 'openVideoModal',
            closeBtnId: 'closeVideoModal',
            hasVideo: true,
            videoId: 'videoFrame'
        },
        {
            id: 'filterModal',
            openBtnId: 'openFilterModal',
            closeBtnId: 'closeFilterModal',
            hasVideo: false
        },
        {
            id: 'depotSelectModal',
            openBtnId: 'openDepotSelectModal',
            closeBtnId: 'closeDepotSelectModal',
            hasVideo: false
        },
        {
            id: 'simulatorModal',
            openBtnId: 'openSimulatorModal',
            closeBtnId: 'closeSimulatorModal',
            hasVideo: false
        }
    ];

    const activeModals = new Map();
    window.modalCloseFunctions = window.modalCloseFunctions || new Map();

    function initModal(config) {
        const modal = document.getElementById(config.id);
        const openBtn = document.getElementById(config.openBtnId);
        const closeBtn = document.getElementById(config.closeBtnId);
        const video = config.hasVideo ? document.getElementById(config.videoId) : null;

        if (!modal || !openBtn) return;

        const closeModal = () => {
            modal.classList.remove('active');
            activeModals.delete(config.id);
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
            document.body.style.overflow = '';
            document.body.classList.remove('modal-open');
        };

        window.modalCloseFunctions.set(config.id, closeModal);

        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            modal.classList.add('active');
            activeModals.set(config.id, closeModal);
            if (video) video.play();
            document.body.style.overflow = 'hidden';
            document.body.classList.add('modal-open');
        });

        closeBtn?.addEventListener('click', (e) => {
            e.preventDefault();
            closeModal();
        });

        modal.addEventListener('click', (e) => {
            if (e.target === modal) closeModal();
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && activeModals.size > 0) {
            const lastModal = Array.from(activeModals.values()).pop();
            lastModal?.();
        }
    });

    modals.forEach(initModal);

    const modal = document.getElementById('videoModal');
    const closeBtn = document.getElementById('closeVideoModal');
    const iframe = modal.querySelector('iframe');

    closeBtn.addEventListener('click', () => {

        // stop la vidéo
        const iframeSrc = iframe.src;
        iframe.src = '';
        iframe.src = iframeSrc;

        // ferme la modal
        modal.classList.remove('is-open');
    });
});